import {Component, ElementRef, ViewChild} from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  AlertController,
  ToastController,
  ModalController
} from "ionic-angular";
import { DatabaseProvider } from "../../providers/database/database";
import { Subject } from "rxjs";
import { AuthProvider } from "../../providers/auth/auth";
import * as moment from "moment";
import {AdminPrescriptionsNotePage} from "../admin-prescriptions-note/admin-prescriptions-note";
import {OrderDetailsPage} from "../order-details/order-details";
import {DatatableComponent} from "@swimlane/ngx-datatable";

@IonicPage()
@Component({
  selector: "page-admin-prescriptions",
  templateUrl: "admin-prescriptions.html"
})
export class AdminPrescriptionsPage {
  private ngUnsubscribe: Subject<any> = new Subject();
  clinic_name: string;
  clinic_id: string;
  clinic_province: string;
  status: string = "unfilled";
  display_name: string;
  isLoading = false;
  province: any;
  is_not_clinic_user: any;
  @ViewChild('myTable') table: DatatableComponent;
  searchFilter : string = "";
  medicationFilter: Array<string> = [];
  orderNumberFilter: number;
  clinicFilter: Array<string> = [];
  doctorFilter: Array<string> = [];

  archiveSearchBarValue: string = "";
  archiveSearchFilter: string = "";

  rows: any[] = [];
  filtered_rows: any[];
  checked: any = {};
  clinics: any[];
  doctors: any[];

  readonly archivedPageLimit = 50;
  endOfData: boolean = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private readonly auth: AuthProvider,
    public database: DatabaseProvider,
    public alertCtrl: AlertController,
    public toastCtrl: ToastController,
    private modalCtrl: ModalController,
    private el: ElementRef
  ) {
    this.auth.getCurrentUser().then(user => {
      this.display_name = user.display_name;
      this.clinic_name = user.clinic_name;
      this.clinic_id = user.clinic_id;
      this.clinic_province = user.clinic_province;
      this.province = user.roles.retina_admin ? null : (user.clinic_province ? user.clinic_province : 'ON');
      this.is_not_clinic_user = (user.roles.retina_pharmacist || user.roles.retina_admin) && !navParams.get("clinic_user");
      this.getPrescriptions();
    });
  }

  public getPrescriptions() {
    this.isLoading = true;
    this.database.getPrescriptions(this.province, this.is_not_clinic_user, this.clinic_id, (this.status === 'filled'))
      .valueChanges()
      .takeUntil(this.ngUnsubscribe)
      .subscribe(rxs => {
        console.log('Rxs: ', rxs.length)
        this.rows = rxs.filter(r => r.status !== 'Batch');
        this.filtered_rows = rxs.filter(r => r.status !== 'Batch');

        this.isLoading = false;
        // console.log(this.rows);

        if (
          this.searchFilter != "" || 
          this.medicationFilter.length > 0 || 
          this.orderNumberFilter ||
          this.clinicFilter.length > 0 || 
          this.doctorFilter.length > 0) {
          // console.log(this.searchFilter);
          // console.log(this.medicationFilter);
          this.updateFilter();
        }

        this.clinics = [];
        this.doctors = [];
        this.rows.forEach((row) => {
          if (this.clinics.indexOf(row.clinic_name) == -1) {
            this.clinics.push(row.clinic_name);
          }
          if (this.doctors.indexOf(row.doctor.first_name+" "+row.doctor.last_name) == -1) {
            this.doctors.push(row.doctor.first_name+" "+row.doctor.last_name);
          }
          this.createNoteTooltip(row);
          if (this.checked[row.rx_id] === undefined)
            this.checked[row.rx_id] = false;
        });
      });
  }

  public getArchivedPrescriptions(lastPrescription) {
    this.isLoading = true;
      this.database.getArchivedPrescriptions(this.province, this.is_not_clinic_user, this.clinic_id, lastPrescription, this.archivedPageLimit, this.archiveSearchFilter)
        .valueChanges()
        .takeUntil(this.ngUnsubscribe)
        .subscribe(rxs => {
          this.endOfData = (rxs.length === 0 || this.archiveSearchFilter !== "");

          if (this.archiveSearchFilter !== ""){
            console.log(1);
            this.filtered_rows = rxs.filter((rx) => {
              return rx.clinic_name.toLowerCase().indexOf(this.archiveSearchFilter) !== -1 ||
                rx.doctor.first_name.concat(rx.doctor.last_name).toLowerCase().indexOf(this.archiveSearchFilter) !== -1 ||
                rx.medication_name.toLowerCase().indexOf(this.archiveSearchFilter) !== -1 ||
                rx.patient.full_name.toLowerCase().indexOf(this.archiveSearchFilter) !== -1;
            });
          } else if (!lastPrescription) {
            console.log(2);
            this.filtered_rows = rxs;
            this.table.offset = 0;
            this.table.bodyComponent.updateOffsetY(0);
          } else {
            console.log(3);
            this.filtered_rows = [...this.filtered_rows, ...rxs];
          }

          this.isLoading = false;
          console.log(this.filtered_rows);
    });

  }

  createNoteTooltip(row) {
    let tooltip = "";
    if (row.note) {
      tooltip += row.pharmacist_note? `Clinic Note: ${row.note} - `: `Clinic Note: ${row.note}`;
    }
    if (row.pharmacist_note) {
      tooltip += `Pharmacist Note: ${row.pharmacist_note}`
    }
    row.tooltip = tooltip;
  }

  ngOnDestroy() {
    console.log('Leave admin orders and destroy subscriptions');
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  toggleStatus(event) {
    this.ngUnsubscribe.next();
    this.archiveSearchBarValue = ""; this.archiveSearchFilter = "";
    if (this.status != "archived") {
      this.getPrescriptions();
    } else {
      this.getArchivedPrescriptions(null)
    }
  }

  TogglePrescriptionFilled(row) {
    console.log(row.rx_id);
    let element = (<HTMLElement>document.getElementsByClassName("row-"+row.rx_id).item(0));
    element.style["animation"] = 'row-fill 1s ease forwards 1';
    setTimeout(() => {
      this.database.togglePrescriptionFilled(row.rx_id, !row.filled).then(() => element.style["animation"] = 'none')
    }, 1000);
  }

  TogglePrescriptionArchived(row) {
    const isArchive = this.status != "archived";

    const message = "Are you sure you want to "+(isArchive ? "archive" : "unarchive")+" this prescription? <br/><br/>" +
      "Physician: Dr."+row.doctor.last_name+"<br/>" +
      "Patient: "+row.patient.full_name+"<br/>" +
      "Medication: "+row.medication_name+"<br/>" +
      "Date: "+this.formatDate(row.createdAt);

    this.alertCtrl.create({
      title: `Bulk ${isArchive ? 'Archive' : 'Unarchive'}`,
      message: message,
      buttons: [
        {
          text: 'No',
          handler: () => {
          }
        },
        {
          text: 'Yes',
          handler: () => {
            let element = (<HTMLElement>document.getElementsByClassName("row-"+row.rx_id).item(0));
            element.style["animation"] = 'row-fill 1s ease forwards 1';
            setTimeout(async() => {
              await this.database.togglePrescriptionArchived(row.rx_id, isArchive);
              element.style["animation"] = 'none';
            }, 1000);

          }
        }
      ]
    }).present();
  }

  bulkFillToggle() {
    const isFill = this.status === "unfilled";
    let ids = [];

    this.filtered_rows.forEach((row) => {
      if (this.checked[row.rx_id]) {
        ids.push(row.rx_id);
      }
    });

    this.alertCtrl.create({
      title: `Bulk ${isFill? 'Fill':'Unfill'}`,
      message: `Are you sure you want to ${isFill? 'fill':'unfill'} ${ids.length} prescriptions?`,
      buttons: [
        {
          text: 'No',
          handler: () => {}
        },
        {
          text: 'Yes',
          handler: () => {
            ids.forEach((id) => {
              this.checked[id] = false;
            });
            this.database.bulkTogglePrescriptionsFilled(ids, isFill);
          }
        }
      ]
    }).present();
  }

  showNoteModal(row) {
    const noteModal = this.modalCtrl.create(AdminPrescriptionsNotePage, {rx: row, is_not_clinic_user: this.is_not_clinic_user});
    noteModal.present();
  }

  showPharmaNote(row) {
    if (row.pharmacist_note_kroll) {
      if (row.pharmacist_note_kroll.length > 0) {
        return true;
      } 
    }
    if (row.pharmacist_note)  {
      return true;
    }
    return false;
  }

  pharmacyNoteCount(row)  {
    let notecount = 0;
    if (row.pharmacist_note) {
      notecount++;
    }
    if (row.pharmacist_note_kroll) {
      if (row.pharmacist_note_kroll.length > 0) notecount = notecount + row.pharmacist_note_kroll.length;
    }
    return notecount;
  }

  isNoteArray(note) {
   if(Array.isArray(note)) {
      return true;
    } else {
      return false;
    }
  }

  updateFilter() {
    this.filtered_rows = this.rows;
    if (this.searchFilter !== "")
      this.updateSearchFilter();
    if (this.medicationFilter.length > 0)
      this.updateMedicationFilter();
    if (this.clinicFilter.length > 0)
      this.updateClinicFilter();
    if (this.doctorFilter.length > 0)
      this.updateDoctorFilter();

    if (this.orderNumberFilter)
      this.updateOrderNumberFilter();
    else
      this.resetOrderNumberFilter();
  }

  updateSearchFilter() {
    this.filtered_rows = this.filtered_rows.filter((rx) => {
      return rx.clinic_name.toLowerCase().indexOf(this.searchFilter) !== -1 ||
        rx.doctor.first_name.concat(rx.doctor.last_name).toLowerCase().indexOf(this.searchFilter) !== -1 ||
        rx.medication_name.toLowerCase().indexOf(this.searchFilter) !== -1 ||
        rx.patient.full_name.toLowerCase().indexOf(this.searchFilter) !== -1 ||
        rx.order?.number?.toLowerCase().indexOf(this.searchFilter) !== -1 ||
        (rx.location.address + " " + rx.location.city + ", " + rx.clinic_province).toLowerCase().indexOf(this.searchFilter) !== -1;
    });
  }

  resetSearchFilter() {
    this.searchFilter = "";
  }

  updateMedicationFilter() {
    this.filtered_rows = this.filtered_rows.filter((rx) => this.medicationFilter.indexOf(rx.medication_name) > -1);
    document.getElementById("medication-filter").classList.add("active-filter");
  }
  resetMedicationFilter() {
    this.medicationFilter = [];
    document.getElementById("medication-filter").classList.remove("active-filter");
  }

  updateOrderNumberFilter() {
    this.filtered_rows = this.filtered_rows.filter((rx) => rx.order?.number?.includes(this.orderNumberFilter.toString()))
    document.getElementById("order-number-filter").classList.add("active-filter");
  }

  resetOrderNumberFilter() {
    this.orderNumberFilter = null;
    document.getElementById("order-number-filter").classList.remove("active-filter");
  }

  updateClinicFilter() {
    this.filtered_rows = this.filtered_rows.filter((rx) => this.clinicFilter.indexOf(rx.clinic_name) > -1);
    document.getElementById("clinic-filter").classList.add("active-filter");
  }

  resetClinicFilter() {
    this.clinicFilter = [];
    document.getElementById("clinic-filter").classList.remove("active-filter");
  }

  updateDoctorFilter() {
    this.filtered_rows = this.filtered_rows.filter((rx) => this.doctorFilter.indexOf(rx.doctor.first_name+" "+rx.doctor.last_name) > -1);
    document.getElementById("physician-filter").classList.add("active-filter");
  }

  resetDoctorFilter() {
    this.doctorFilter = [];
    document.getElementById("physician-filter").classList.remove("active-filter");
  }

  clearAllFilters() {
    this.filtered_rows = this.rows;
    this.resetSearchFilter();
    this.resetMedicationFilter();
    this.resetClinicFilter();
    this.resetDoctorFilter();
    this.resetOrderNumberFilter();
  }

  openPrescriptionImage(url) {
    window.open(url, "_blank");
  }

  openOrderDetails(order_id) {
    this.database.getOrder(order_id)
      .valueChanges()
      .subscribe(
        (order) => this.navCtrl.push(OrderDetailsPage, {order: order}),
        error => {},
        () => {}
        )
  }

  getRowClass(row) {
    const idString: string = "row-"+row.rx_id;
    let ret = {};
    ret[idString] = true;
    if (!row.filled && !row.archived_date) {
      const fifteenDays: number = parseInt(moment().subtract(15, "day").format("X"));
      const thirtyDays: number = parseInt(moment().subtract(30, "day").format("X"));
      ret["old"] = row.createdAt.seconds <= fifteenDays;
      ret["very-old"] = row.createdAt.seconds <= thirtyDays;
    }

    return ret;
  }

  toggleAllBoxes(toggle) {
    this.filtered_rows.forEach((row) => this.checked[row.rx_id] = toggle)
  }

  public formatDate(date) {
    if (date != null){
      let myMoment: moment.Moment;
      if (date.seconds) {
        myMoment = moment.unix(date.seconds);
      } else {
        myMoment = moment(date);
      }
      return myMoment.format("YYYY MMM DD, h:mm A");
    }
    else
      return "";
  }

  createOrderNumber(number: number) {
    return "ORD" + ("0000" + number).slice(-5);
  }

  onScroll(scrollEvent: any) {
    if (scrollEvent.target && this.status === "archived" && !this.endOfData &&
      scrollEvent.target.scrollTop + scrollEvent.target.clientHeight >= scrollEvent.target.scrollHeight && !this.isLoading)
    {
      console.log("end");
      this.ngUnsubscribe.next();
      this.getArchivedPrescriptions(this.filtered_rows[this.filtered_rows.length - 1].archived_date)
    }
  }

  searchArchive() {
    if (this.archiveSearchBarValue != "") {
      this.archiveSearchFilter = this.archiveSearchBarValue;
      this.ngUnsubscribe.next();
      this.getArchivedPrescriptions(null)
    }
  }

  clearArchiveSearch() {
    this.archiveSearchBarValue = "";
    this.archiveSearchFilter = "";
    this.ngUnsubscribe.next();
    this.getArchivedPrescriptions(null);
  }

  enterListener(keyCode) {
    if (keyCode === 13) {
      this.searchArchive();
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/admin-prescriptions/admin-prescriptions.ts